// Copyright (c) 2020 Deere & Company

import PartsCoverageSearchReport from './components/parts-coverage-search-report';
import actionCreators from './action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    ...state.reports.partsCoverageSearch,
    customer: state.customer.details,
    measurementReadings: state.latestPerUnitMeasurements
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const pathName = parentProps.location.pathname;
    const queryParams = parentProps.location.query;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        pathName,
        queryParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(PartsCoverageSearchReport);



// WEBPACK FOOTER //
// ./src/reports/parts-coverage-search/state-connector.js